





















































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { getCookie } from "../JS/cookie"; //使用getCookie方法
import axios from "axios";
@Component({
  components: {}
})
export default class LeftMenu extends Vue {
  @Prop() TemplateId!: any;
  @Provide() activeTencent: any;
  @Provide() activeCate: any = "";
  @Provide() tempCateList: any = "";
  @Provide() tempList: any = "";
  @Provide() tempGroupList: any = "";
  @Provide() activeTempCate: any = "";
  @Provide() activeTempValue: any = {};
  @Provide() colNum: number = 0;
  @Provide() SearchKeywords: any = "";
  created() {
    let _this = this;
    // 获取缓存中的当前公众号
    _this.activeTencent = JSON.parse(
      Utils.decrypt(localStorage.getItem("activeTencent") as any, "")
    );

    _this.loadCategoryList();
    _this.loadMessageList();
    console.log(this.TemplateId);
    if (this.TemplateId != undefined) {
      this.activeTempValue = _this.tempList.filter((item: any, index: any) =>
        item.ID.includes(this.TemplateId)
      );
      console.log(this.TemplateId);
    }
  }
  filterTempGroupList() {
    let _this = this;
    let grouList: any = [];
    _this.tempList.forEach((temp: any) => {
      if (temp.template_category == _this.activeTempCate.TypeName) {
        grouList.push(temp);
      }
    });
    _this.tempGroupList = grouList;
    _this.colNum = Math.ceil(_this.tempGroupList.length / 3);
  }

  // 搜索素材
  searchFodder(activeCate: any) {
    this.loadMessageList();
    this.activeCate = "全部";
  }
  chooseTempCate(clickCate: any) {
    let _this = this;
    if (clickCate == "all") {
      _this.tempGroupList = _this.tempList;
      _this.activeCate = "全部";
      _this.colNum = Math.ceil(_this.tempGroupList.length / 3);
    } else {
      _this.activeCate = _this.activeTempCate = clickCate;
      _this.filterTempGroupList();
    }
  }
  chooseTemp(clickTemp: any) {
    let _this = this;
    console.log(clickTemp);
    _this.activeTempValue = clickTemp;
    this.TemplateId = clickTemp.ID;
    console.log(this.TemplateId);
    localStorage.setItem("TemplateId", clickTemp.ID);
  }
  pushChooseTemplate() {
    let _this = this;
    if (_this.activeTempValue.length == 0) {
      this.$message("未选择模板消息！");
      return;
    }
    // _this.momentDataArr[_this.activeRow].rowArr[5].data = _this.activeTempValue;
    // _this.replyDialogVisible = false;
  }
  toCreateTemp() {
    let routeData = this.$router.resolve({
      name: "/tenants/tenantsView/wx-message_ModelTable",
      params: { parentcode: "M159" }
    });
    localStorage.setItem("menuKey", "M159");
    localStorage.setItem("slideKey", "M198");
    localStorage.setItem("target", "_blank");
    window.open(routeData.href, "_blank");
  }
  /** 加载模板数据 */
  async loadMessageList() {
    let _this = this;
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.activeTencent.Aid
        },
        {
          Name: "status",
          Value: 1
        }
      ]
    };
    var res: any = await httpApi.GetAppMessageTemplateList(params);
    if (res.ErrorCode == 0) {
      _this.tempList = res.output[0].value;
      _this.filterTempGroupList();
      var result = res.output[0].value;
      if (this.SearchKeywords) {
        _this.tempGroupList = result.filter((item: any, index: any) =>
          item.template_title.includes(this.SearchKeywords)
        );
      }
    } else {
      this.$message.error(res.ErrorMessage);
    }
  }
  /** 加载分类列表 */
  async loadCategoryList() {
    let _this = this;
    let params: any = {
      Input: [
        {
          Name: "Model",
          Value: { ApplicationId: this.activeTencent.Aid, Status: 1 }
        }
      ]
    };
    var res: any = await httpApi.GetAppMessageTemplateType(params);
    if (res.ErrorCode == 0) {
      _this.tempCateList = res.output[0].value;
      _this.activeTempCate = this.tempCateList[0];
      _this.activeCate = this.activeTempCate;
    } else {
      this.$message.error("加载失败：" + res.ErrorMessage);
    }
  }
}
